import { useState, useEffect, useRef } from 'react';

export default function Architecture() {
  const [isVisible, setIsVisible] = useState(false);
  const sectionRef = useRef<HTMLElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setIsVisible(true);
          }
        });
      },
      { threshold: 0.1 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => {
      if (sectionRef.current) {
        observer.unobserve(sectionRef.current);
      }
    };
  }, []);

  return (
    <section ref={sectionRef} className="py-20 bg-gradient-to-r from-[#2a4b7c] to-[#3d5a80] text-white">
      <div className="container mx-auto px-6">
        <div className={`max-w-4xl mx-auto text-center mb-16 transition-all duration-1000 ${
          isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
        }`}>
          <h2 className="text-3xl md:text-4xl font-bold mb-6">
            Kiến trúc SaaS - Sẵn sàng mở rộng
          </h2>
          <p className="text-lg text-blue-100">
            Nền tảng được thiết kế để tích hợp và phát triển cùng doanh nghiệp
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
          {[
            { icon: 'ri-cloud-line', title: 'Multi-tenant', desc: 'Hỗ trợ nhiều doanh nghiệp trên cùng nền tảng', color: '#06b6d4' },
            { icon: 'ri-shield-user-line', title: 'Phân quyền linh hoạt', desc: 'Quản lý truy cập theo vai trò và cấp độ', color: '#2ecc71' },
            { icon: 'ri-links-line', title: 'API Integration', desc: 'Tích hợp HRM, LMS, ATS hiện có', color: '#2a5bd7' },
            { icon: 'ri-ai-generate', title: 'AI-Ready', desc: 'Sẵn sàng mở rộng AI & phân tích dự báo', color: '#06b6d4' }
          ].map((item, index) => (
            <div 
              key={index}
              className={`text-center p-6 bg-white/10 rounded-xl backdrop-blur-sm border border-white/20 hover:bg-white/20 hover:scale-105 transition-all duration-500 ${
                isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
              }`}
              style={{ transitionDelay: `${200 + index * 100}ms` }}
            >
              <i className={`${item.icon} text-3xl mb-4`} style={{ color: item.color }}></i>
              <h3 className="font-bold mb-2">{item.title}</h3>
              <p className="text-sm text-blue-100">{item.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
